<template>
    <div class="new-account">
        <v-dialog v-model="dialog_reg_sent" width="400" persistent>
            <v-card>
                <v-card-title class="subheading success lighten-2" primary-title>
                    <v-icon left>how_to_vote</v-icon>
                    <span class="font-weight-medium">Запрос отправлен</span>
                </v-card-title>
                <v-card-text class="text-xs-center">
                    <p>Запрос на регистрацию успешно отправлен.</p>
                    <p>В ближайшее время менеджер свяжется с вами.</p>
                    <v-divider></v-divider>
                    <p></p>
                    <p></p>
                </v-card-text>
                <v-card-actions class="bg_navbar">
                    <v-layout row wrap justify-end>
                        <v-flex xs12 md4>
                            <v-btn block color="secondary" flat @click="dialog_reg_sent = false">
                                Закрыть
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-layout row wrap justify-center>
            <v-flex xs12 md8 lg6>
                <v-card>
                    <v-card-title primary-title class="text_navbar">
                        <span class="white--text headline font-weight-medium hidden-sm-and-down">
                            Заявка на сотрудничество
                        </span>
                        <span class="white--text subheading font-weight-medium hidden-md-and-up">
                            Заявка на сотрудничество
                        </span>
                    </v-card-title>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-card-text>
                            <v-container grid-list-md fluid>
                                <small>*Обязательные поля</small>
                                <v-layout row wrap justify-space-between>
                                    <v-flex xs12 md5>
                                        <v-text-field
                                                v-model="reg_model.organization" color="accent"
                                                :rules="rules.required"
                                                label="Наименование юр. лица или ИП*" required
                                                placeholder=" "
                                        ></v-text-field>
                                        <v-text-field
                                                v-model="reg_model.inn" color="accent"
                                                mask="############"
                                                :counter="12" :rules="rules.inn"
                                                label="ИНН*" required
                                                placeholder="10-12 цифр"
                                        ></v-text-field>
                                        <v-autocomplete
                                                :items="regions" :rules="rules.required" :filter="custom_filter"
                                                item-text="name" item-value="name" v-model="reg_model.region"
                                                placeholder="Начните вводить"
                                                persistent-hint
                                                hint="Если вашего региона нет в списке, выберите 'Другое'"
                                                hide-no-data label="Регион*" required
                                        ></v-autocomplete>
                                        <br/>
                                        <span>Вы выступаете как:</span>
                                        <v-layout row wrap>
                                            <v-checkbox
                                                    color="accent"
                                                    v-model="reg_model.is_buyer"
                                                    label="Покупатель"
                                            ></v-checkbox>
                                            <v-checkbox color="accent"
                                                        v-model="reg_model.is_seller"
                                                        label="Поставщик"
                                            ></v-checkbox>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 md5>
                                        <v-text-field
                                                v-model="reg_model.contact_name" color="accent"
                                                label="Контактное лицо (Имя)"
                                                placeholder="Кого спросить?"
                                        ></v-text-field>
                                        <v-text-field
                                                v-model="reg_model.contact_phone_primary" color="accent"
                                                mask="(###) ### - ####"
                                                placeholder="(987) 654 - 3210"
                                                :rules="rules.required"
                                                label="Телефон для связи*" required
                                        ></v-text-field>
                                        <v-text-field
                                                v-model="reg_model.contact_phone_secondary" color="accent"
                                                placeholder="+7 (987) 654 - 3210 доб. 1234"
                                                hint="В любом формате"
                                                label="Дополнительный телефон"
                                        ></v-text-field>
                                        <v-text-field
                                                v-model="reg_model.email" color="accent"
                                                placeholder="example@contoso.com"
                                                :rules="rules.email"
                                                label="Контактный E-mail*" required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                                v-model="reg_model.commentary" color="accent"
                                                name="input-commentary"
                                                label="Комментарий"
                                                hint="Произвольный текст"
                                                :rules="[rules.length(1024)]" counter="1024"
                                                auto-grow rows="3"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="bg_navbar">
                            <v-container class="mx-2" fluid>
                                <v-layout wrap pa-1 align-center justify-center column fill-height>
                                        <v-flex>
                                            <vue-recaptcha class="hidden-xs-only"
                                                           theme="light" size="normal"
                                                           ref="recaptcha"
                                                           @verify="onVerify"
                                                           @expired="onExpired"
                                                           :sitekey="sitekey">
                                            </vue-recaptcha>
                                            <vue-recaptcha class="hidden-sm-and-up"
                                                           theme="light" size="compact"
                                                           ref="recaptcha"
                                                           @verify="onVerify"
                                                           @expired="onExpired"
                                                           :sitekey="sitekey">
                                            </vue-recaptcha>
                                            <br />
                                            <v-btn block large color="success" fill-height
                                                   :disabled="!valid || !recaptcha" @click="validate">
                                                <span class="subheading font-weight-medium">Отправить</span>
                                                <v-icon right medium>send</v-icon>
                                            </v-btn>
                                        </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar v-model="snack" :timeout="10000" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    import $ from 'jquery';
    import VueRecaptcha from 'vue-recaptcha';
    import { Globals } from '@/globals.js';
    export default {
        name: "NewAccount",
        data(){
            return {
                // Register field
                reg_model: {
                    organization: '',
                    inn: '',
                    contact_name: '',
                    contact_phone_primary: '',
                    contact_phone_secondary: '',
                    email: '',
                    is_buyer: false,
                    is_seller: false,
                    region: '',
                    commentary: '',
                },
                regions: [
                    {id: 0, name: 'Другое'},
                    {id: 22, name: 'Алтайский край'},
                    {id: 28, name: 'Амурская область'},
                    {id: 29, name: 'Архангельская область'},
                    {id: 30, name: 'Астраханская область'},
                    {id: 31, name: 'Белгородская область'},
                    {id: 32, name: 'Брянская область'},
                    {id: 33, name: 'Владимирская область'},
                    {id: 34, name: 'Волгоградская область'},
                    {id: 35, name: 'Вологодская область'},
                    {id: 36, name: 'Воронежская область'},
                    {id: 77, name: 'г. Москва'},
                    {id: 79, name: 'Еврейская автономная область'},
                    {id: 75, name: 'Забайкальский край'},
                    {id: 37, name: 'Ивановская область'},
                    {id: 99, name: 'Иные территории, включая город и космодром Байконур'},
                    {id: 38, name: 'Иркутская область'},
                    {id: 7, name: 'Кабардино-Балкарская Республика'},
                    {id: 39, name: 'Калининградская область'},
                    {id: 40, name: 'Калужская область'},
                    {id: 41, name: 'Камчатский край'},
                    {id: 9, name: 'Карачаево-Черкесская Республика'},
                    {id: 42, name: 'Кемеровская область'},
                    {id: 43, name: 'Кировская область'},
                    {id: 44, name: 'Костромская область'},
                    {id: 23, name: 'Краснодарский край'},
                    {id: 24, name: 'Красноярский край'},
                    {id: 45, name: 'Курганская область'},
                    {id: 46, name: 'Курская область'},
                    {id: 47, name: 'Ленинградская область'},
                    {id: 48, name: 'Липецкая область'},
                    {id: 49, name: 'Магаданская область'},
                    {id: 50, name: 'Московская область'},
                    {id: 51, name: 'Мурманская область'},
                    {id: 83, name: 'Ненецкий автономный округ'},
                    {id: 52, name: 'Нижегородская область'},
                    {id: 53, name: 'Новгородская область'},
                    {id: 54, name: 'Новосибирская область'},
                    {id: 55, name: 'Омская область'},
                    {id: 56, name: 'Оренбургская область'},
                    {id: 57, name: 'Орловская область'},
                    {id: 58, name: 'Пензенская область'},
                    {id: 59, name: 'Пермский край'},
                    {id: 25, name: 'Приморский край'},
                    {id: 60, name: 'Псковская область'},
                    {id: 1, name: 'Республика Адыгея (Адыгея)'},
                    {id: 4, name: 'Республика Алтай'},
                    {id: 2, name: 'Республика Башкортостан'},
                    {id: 3, name: 'Республика Бурятия'},
                    {id: 5, name: 'Республика Дагестан'},
                    {id: 6, name: 'Республика Ингушетия'},
                    {id: 8, name: 'Республика Калмыкия'},
                    {id: 10, name: 'Республика Карелия'},
                    {id: 11, name: 'Республика Коми'},
                    {id: 91, name: 'Республика Крым'},
                    {id: 12, name: 'Республика Марий Эл'},
                    {id: 13, name: 'Республика Мордовия'},
                    {id: 14, name: 'Республика Саха (Якутия)'},
                    {id: 15, name: 'Республика Северная Осетия - Алания'},
                    {id: 16, name: 'Республика Татарстан (Татарстан)'},
                    {id: 17, name: 'Республика Тыва'},
                    {id: 19, name: 'Республика Хакасия'},
                    {id: 61, name: 'Ростовская область'},
                    {id: 62, name: 'Рязанская область'},
                    {id: 63, name: 'Самарская область'},
                    {id: 78, name: 'Санкт-Петербург'},
                    {id: 64, name: 'Саратовская область'},
                    {id: 65, name: 'Сахалинская область'},
                    {id: 66, name: 'Свердловская область'},
                    {id: 92, name: 'Севастополь'},
                    {id: 67, name: 'Смоленская область'},
                    {id: 26, name: 'Ставропольский край'},
                    {id: 68, name: 'Тамбовская область'},
                    {id: 69, name: 'Тверская область'},
                    {id: 70, name: 'Томская область'},
                    {id: 71, name: 'Тульская область'},
                    {id: 72, name: 'Тюменская область'},
                    {id: 18, name: 'Удмуртская Республика'},
                    {id: 73, name: 'Ульяновская область'},
                    {id: 27, name: 'Хабаровский край'},
                    {id: 86, name: 'Ханты-Мансийский автономный округ - Югра'},
                    {id: 74, name: 'Челябинская область'},
                    {id: 20, name: 'Чеченская Республика'},
                    {id: 21, name: 'Чувашская Республика - Чувашия'},
                    {id: 87, name: 'Чукотский автономный округ'},
                    {id: 89, name: 'Ямало-Ненецкий автономный округ'},
                    {id: 76, name: 'Ярославская область'},
                ],
                // Rules
                rules: {
                    length:
                        len => v => (v || '').length < len || `Слишком большое сообщение. Максимум ${len} символов.`,

                    required: [
                        v => !!v || 'Это поле обязательно для заполнения',
                    ],
                    inn: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => (v && v.length >= 10) || 'Не менее 10 цифр'
                    ],
                    contactName: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => (v && v.length >= 3) || 'Не менее 3 символов'
                    ],
                    email: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Некоректный E-mail'
                    ],
                },
                // Dialogs
                dialog_reg_sent: false,
                // Validate
                valid: false,
                recaptcha: false,
                recaptcha_validation: '',
                sitekey: Globals.RECAPTCHA_SITE_KEY,
                // Snack
                snack: false,
                snackColor: '',
                snackText: '',
            }
        },
        components: {
            VueRecaptcha,
        },
        created() {
        },
        methods: {
            new_account_send_mail(reg_info, recaptcha_validation) {
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'service/account/new/',
                    type: 'POST',
                    data: {
                        reg_info: reg_info,
                        validation: recaptcha_validation,
                    },
                    success: () => {
                        this.show_snack('success', 'Запрос отправлен');
                        this.dialog_reg_sent = true;
                        this.resetForm();
                    },
                    error: (response) => {
                        this.show_snack('error', 'Ошибка: ' + response.status);
                    },
                })
            },
            // Validations
            custom_filter(item, queryText) {
                const textOne = item.name.toLowerCase()
                const searchText = queryText.toLowerCase()

                return textOne.indexOf(searchText) > -1
            },
            validate() {
                if (this.$refs.form.validate() && this.recaptcha) {
                    this.new_account_send_mail(this.reg_model, this.recaptcha_validation);
                }
            },
            // RE-Captcha
            onVerify: function (response) {
                //console.log('Verify: ' + response);
                this.recaptcha_validation = response;
                this.recaptcha = true;
            },
            onExpired: function () {
                //console.log('Expired')
                this.recaptcha_validation = '';
                this.recaptcha = false;
            },
            resetRecaptcha() {
                this.recaptcha = false;
                this.recaptcha_validation = '';
                this.$refs.recaptcha.reset() // Direct call reset method
            },
            // Form Reset
            resetForm() {
                this.$refs.form.reset();
                this.resetRecaptcha();
            },
            // Form MISC
            show_snack(snack_color, snack_text){
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            },
        },
    }
</script>

<style scoped>

</style>